import { P, match } from 'ts-pattern'

import { SyncErrorTaskInput } from './types'

const HUBSPOT_RECORDS_BASE_URL = 'https://app.hubspot.com/contacts'
const QUICKBOOKS_PRODUCTION_HOST = 'https://qbo.intuit.com'
const QUICKBOOKS_SANDBOX_HOST = 'https://sandbox.qbo.intuit.com'
const QUICKBOOKS_ADVANCED_SETTINGS_PATH = '/app/accountsettings?p=advanced'

export const syncErrorExternalUrl = (
  input: SyncErrorTaskInput
): string | undefined =>
  match(input)
    .with(
      {
        externalService: 'HubSpot',
        externalId: P.string.minLength(1),
        externalAccountId: P.string.minLength(1)
      },
      ({ externalEntityType, externalId, externalAccountId }) => {
        const recordPath = hubspotRecordPath(externalEntityType)

        return recordPath
          ? `${HUBSPOT_RECORDS_BASE_URL}/${externalAccountId}/${recordPath}/${externalId}`
          : undefined
      }
    )
    .otherwise(() => undefined)

export const quickbooksAdvancedSettingsUrl = (
  usesProductionQuickbooks: boolean
): string =>
  `${usesProductionQuickbooks ? QUICKBOOKS_PRODUCTION_HOST : QUICKBOOKS_SANDBOX_HOST}${QUICKBOOKS_ADVANCED_SETTINGS_PATH}`

const hubspotRecordPath = (externalEntityType: string): string | undefined =>
  match(externalEntityType)
    .with('CUSTOMER', () => 'company')
    .with('QUOTE', () => 'deal')
    .otherwise(() => undefined)

export const quickbooksPaymentUrl = (
  externalPaymentId: string,
  usesProductionQuickbooks: boolean
): string =>
  `${usesProductionQuickbooks ? QUICKBOOKS_PRODUCTION_HOST : QUICKBOOKS_SANDBOX_HOST}/app/recvpayment?txnId=${encodeURIComponent(externalPaymentId)}`
